import React from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";

import Floor1K5 from './Components/Floor1K5'
import Floor2K5 from './Components/Floor2K5'
import Floor3K5 from './Components/Floor3K5'
import Floor4K5 from './Components/Floor4K5'
import Floor5K5 from './Components/Floor5K5'
import Floor6K5 from './Components/Floor6K5'
import Floor7K5 from './Components/Floor7K5'
import Floor8K5 from './Components/Floor8K5'
import Floor9K5 from './Components/Floor9K5'
import Floor10K5 from './Components/Floor10K5'
import Floor11K5 from './Components/Floor11K5'
import Floor2K6 from './Components/Floor2K6'

//k6
import Floor1K6 from './Components/Floor1K6'
import Floor3K6 from './Components/Floor3K6'
import Floor4K6 from './Components/Floor4K6'
import Floor5K6 from './Components/Floor5K6'
import Floor6K6 from './Components/Floor6K6'
import Floor7K6 from './Components/Floor7K6'
import Floor8K6 from './Components/Floor8K6'
import Floor9K6 from './Components/Floor9K6'
import Floor10K6 from './Components/Floor10K6'
function ClickFloor() {
  return (
  <div className='w-[100vw] relative mb-40  mt-40 '>
      <div className='w-[100vw] relative '>
      <LazyLoadImage className='w-[100vw] top-[0vw] right-[0vw] relative ' src="/images/click/clean-images/click-floors.jpg" alt="" />
     

      {/* k6 */}
      <Floor1K6/>
      <Floor2K6/>
      <Floor3K6/>
      <Floor4K6/>
      <Floor5K6/>
      <Floor6K6/>
      <Floor7K6/>
      <Floor8K6/>
      <Floor9K6/>
      <Floor10K6/>
      <Floor1K5 />
      <Floor2K5 />
      <Floor3K5 />
      <Floor4K5 />
      <Floor5K5 />
      <Floor6K5 />
      <Floor7K5 /> 
      <Floor8K5 />
      <Floor9K5 />
      <Floor10K5 />
      <Floor11K5 /> 
    </div>
  </div>
  )
}

export default ClickFloor